import { setLocale } from "yup";

import { Translate } from "@/redux/modules/value/translations/translations.provider";

setLocale({
    mixed: {
        required:
            ({ path }) =>
            (label?: string) =>
            (t: Translate) =>
                t("form.validation.input.required", label || path)
    },
    string: {
        email:
            ({ path }) =>
            (label?: string) =>
            (t: Translate) =>
                t("form.validation.input.string.email", label || path),
        min:
            ({ path, min }) =>
            (label?: string) =>
            (t: Translate) =>
                t("form.validation.input.string.min", label || path, min),
        max:
            ({ path, max }) =>
            (label?: string) =>
            (t: Translate) =>
                t("form.validation.input.string.max", label || path, max)
    },
    number: {
        min:
            ({ path, min }) =>
            (label?: string) =>
            (t: Translate) =>
                t("form.validation.input.number.min", label || path, min),
        max:
            ({ path, max }) =>
            (label?: string) =>
            (t: Translate) =>
                t("form.validation.input.number.max", label || path, max),
        integer:
            ({ path }) =>
            (label?: string) =>
            (t: Translate) =>
                t("form.validation.input.number.integer", label || path),
        positive:
            ({ path }) =>
            (label?: string) =>
            (t: Translate) =>
                t("form.validation.input.number.positive", label || path)
    }
});
